module.exports = __webpack_public_path__ + "static/media/plant_phase_two.e4073ad1.png";